<ng-container *ngrxLet="data$.asObservable() as _data">
  <mat-card class="card" [ngClass]="_data | backdropClass">
    <mat-card-title class="cardHeader" [ngClass]="{'cardHeader--noTabs': !shouldDisplayDprCardTabs}">
      <div class="d-flex justify-content-between">
        <div data-testId="dpr-displayId" class="h5">
          #{{ _data.displayId | dprTitle }} &nbsp; - &nbsp; {{ utcDate | date: 'yyyy' }}
        </div>
        <ng-container>
          <mat-icon
            class="icon--large"
            *ngIf="_data.dprDetailLockedDate; else warningIconTemplate"
            [attr.data-testId]="'dpr-card-locked-' + _data.displayId"
            svgIcon="lock"
            matTooltip="Locked"
            i18n-matTooltip="@@dpr.dprCard.attrLocked"
          ></mat-icon>
          <ng-template #warningIconTemplate>
            <mat-icon
              [matTooltipClass]="'aqa-dpr-card-tooltip-warning-'+ _data.displayId"
              [attr.data-testId]="'dpr-card-warning-' + _data.displayId"
              class="icon--large"
              [svgIcon]="_data | warningIcon : 'dprDetailsFirstWarning'"
              [matTooltip]="_data | warningTooltip: customNames : 'dprDetailsFirstWarning': 'dprDetailsWarningStatusTab'"
            ></mat-icon>
          </ng-template>
        </ng-container>
      </div>
      <div [attr.data-testId]="'dpr-card-date-' + _data.displayId" class="h2">
        {{ utcDate | date: 'EEE' }}, {{ utcDate | date: 'MMM' }} {{ utcDate | date: 'dd' }}
      </div>
    </mat-card-title>
    <mat-card-content class="nav nav-justified nav-material">
      <ng-container *ngIf="!shouldDisplayDprCardTabs; else dprCardTabs">
        <app-dpr-card-details
          [data$]="data$.asObservable()"
          [canEdit]="canEdit"
          [isAppOnline]="isAppOnline"
          [isDigitalSignatureEnabled]="isDigitalSignatureEnabled"
          (uploadSignedReport)="onUploadSignedReport($event)"
        ></app-dpr-card-details>
      </ng-container>
    </mat-card-content>
    <mat-card-actions class="cardFooter">
      <ng-container *ngIf="!_data.dprDetailLockedDate; else lockedButtons">
        <button
          mat-flat-button
          [attr.data-testId]="'dpr-card-edit-' + _data.displayId"
          class="mat-secondary"
          (click)="goToDprDetails(_data.dprDetailId)"
        >
          <mat-icon svgIcon="drive-file-rename"></mat-icon>
          <span>{{canEdit ? btnEdit : canEditExternalPartyComment ? btnReview : btnView}}</span>
        </button>
        <button
          *ngIf="canEdit"
          [attr.data-testId]="'dpr-card-lock-' + _data.displayId"
          mat-button
          color="primary"
          (click)="confirmLockDPR()"
          [disabled]="_data.dprDetailsFirstWarning >= 0"
        >
          <span i18n="@@dpr.dprCard.btnLock">Lock</span>
        </button>
      </ng-container>

      <ng-template #lockedButtons>
        <button
          *ngIf="canEdit"
          data-testId="unlock-and-edit"
          mat-flat-button
          class="mat-secondary text-truncate"
          (click)="confirmUnlock()"
        >
          <mat-icon svgIcon="lock-open-variant"></mat-icon>
          <span i18n="@@dpr.dprCard.btnUnlockAndEdit">Unlock & Edit</span>
        </button>
        <button
          mat-button
          data-testId="view-locked-dpr"
          color="primary"
          [ngClass]="{'mat-flat-button mat-secondary': !canEdit}"
          (click)="goToDprDetails(_data.dprDetailId)"
        >
          <mat-icon *ngIf="!canEdit" svgIcon="drive-file-rename"></mat-icon>
          <span i18n="@@dpr.dprCard.btnView">View</span>
        </button>
        <button
          *ngIf="canEdit && (_data | displayESignButton: isAppOnline : isDigitalSignatureEnabled)"
          data-testId="e-sign"
          mat-button
          color="primary"
          (click)="onOpenDigitalSignatureModal()"
        >
          <span i18n="@@dpr.dprCard.btnESign">E-Sign</span>
        </button>
      </ng-template>
    </mat-card-actions>
  </mat-card>

  <ng-template #dprCardTabs>
    <mat-tab-group mat-align-tabs="center" animationDuration="0ms">
      <mat-tab class="cardContent">
        <ng-template mat-tab-label>
          <mat-icon svgIcon="inbox" mat-list-icon></mat-icon>
          <span [attr.data-testId]="'dpr-card-detail-tab-' + _data.displayId" i18n="@@dpr.dprCard.lblDetails">
            Details
          </span>
        </ng-template>
        <app-dpr-card-details
          [data$]="data$.asObservable()"
          [canEdit]="canEdit"
          [isAppOnline]="isAppOnline"
          [isDigitalSignatureEnabled]="isDigitalSignatureEnabled"
          (uploadSignedReport)="onUploadSignedReport($event)"
        ></app-dpr-card-details>
      </mat-tab>
      <mat-tab class="cardContent" [disabled]="shouldDisableApprovalTab">
        <ng-template mat-tab-label>
          <div
            class="d-flex align-items-center"
            matTooltip="No available approvers"
            [matTooltipDisabled]="!shouldDisableApprovalTab"
            i18n-matTooltip="@@dpr.dprCard.attrNoAvailableApprovers"
          >
            <mat-icon
              mat-list-icon
              *ngIf="onlineApprovers?.length; else accountIconTemplate"
              [svgIcon]="_data | approveStatusIcon : 'dprDetailsApproveStatus' : true"
            ></mat-icon>
            <ng-template #accountIconTemplate>
              <mat-icon mat-list-icon svgIcon="account"></mat-icon>
            </ng-template>
            <span [attr.data-testId]="'dpr-card-approvers-tab-' + _data.displayId" i18n="@@dpr.dprCard.lblApprovers">
              Approvers
            </span>
          </div>
        </ng-template>
        <app-dpr-card-approvers
          [approvers]="approvers"
          [dprApprovers$]="dprApprovers$.asObservable()"
          [onlineApprovers]="onlineApprovers"
          [dprOnlineApprovals]="dprOnlineApprovals$.asObservable() | async"
          [customNames]="customNames"
          [accountId]="accountId"
          [clientId]="clientId"
          [clientName]="clientName"
          [dprDetailId]="_data.dprDetailId"
          [dateTime]="_data.dateTime"
          [displayId]="_data.displayId"
          [revision]="_data.dprDetailRevision"
          [isLocked]="!!_data.dprDetailLockedDate"
          [canEdit]="canEdit"
          [syncStatus$]="dprApproverSyncStatus$.asObservable()"
          (addDprApprover)="addDprApprover($event)"
          (deleteDprApprover)="deleteDprApprover($event)"
          (updateDprApprover)="updateDprApprover($event)"
          (syncOnlineApproval)="syncOnlineApproval($event)"
        ></app-dpr-card-approvers>
      </mat-tab>
    </mat-tab-group>
  </ng-template>
</ng-container>
